module.exports = __webpack_public_path__ + "static/media/Jaipur architecture fest award 1.1.81b755a6.png";